import { Box } from '@material-ui/core';
import { HashLink } from 'react-router-hash-link';

import { NotificationNumberCircle } from '@/components/modules/Funnel/components/NotificationNumberCircle';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { PageHighlightTypeName, PageHighlightTypes } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useUser } from '@/hooks/useUser';

const allowedHighlightsForMCA = [PageHighlightTypeName.INCIDENCE];

export function LoanHighlights() {
  const {
    state: { loanHighlights },
  } = usePageContext();
  const { palette, customBorderRadius } = useCustomTheme();
  const { userEntity } = useUser();

  const getFilteredLoanHighlights = () => {
    if (userEntity?.isRoleMerchantChannelOrAgent) {
      return loanHighlights.filter((highlight) => allowedHighlightsForMCA.includes(highlight.type));
    }
    return loanHighlights;
  };

  const filteredLoanHighlights = getFilteredLoanHighlights();

  return (
    <Box mt={4} mb={2}>
      {!!filteredLoanHighlights.length && (
        <Box display={'flex'} alignItems={'center'} mb={3}>
          <Font variant={'subtitle1'} color={'title'}>
            <Text tId={'ALERTS'} />
          </Font>
          <Box mr={1} ml={1}>
            <NotificationNumberCircle num={filteredLoanHighlights.length} />
          </Box>
        </Box>
      )}
      {filteredLoanHighlights.map((highlight, key) => (
        <HashLink key={`highlight-${key}`} to={`#${highlight.hashId}`} smooth>
          <Box
            style={{
              background: palette.grey[50],
              padding: '8px 10px 8px 8px',
              borderRadius: customBorderRadius.paper,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            <i
              className="material-icons-outlined"
              style={{ verticalAlign: 'text-top', fontSize: '18px', marginRight: '8px', color: palette.text.secondary }}
            >
              {PageHighlightTypes[highlight.type].icon}
            </i>
            <Font variant={'caption'} color={'textPrimary'}>
              <Text tId={highlight.textId} />
            </Font>
          </Box>
        </HashLink>
      ))}
    </Box>
  );
}
